import { Config } from "@/types";

export const config: Config = {
  currency: "AUD",
  currencies: [
    "AED",
    "ALL",
    "AUD",
    "CHF",
    "CNY",
    "DKK",
    "EUR",
    "GBP",
    "HRK",
    "HUF",
    "IDR",
    "ISK",
    "JPY",
    "MAD",
    "MYR",
    "NOK",
    "PHP",
    "PLN",
    "SEK",
    "SGD",
    "THB",
    "TRY",
    "USD",
    "VND",
  ],
  locale: "en-GB",
  locales: [
    "da-DK",
    "de-DE",
    "en-GB",
    "en-IE",
    "en-US",
    "es-ES",
    "fr-FR",
    "fr-MA",
    "is-IS",
    "it-IT",
    "ms-MY",
    "nb-NO",
    "pl-PL",
    "pt-PT",
    "sv-SE",
    "th-TH",
    "tr-TR",
    "zh-CN",
  ],
};

export const site = {
  title: "FurthrShop Experiences",
  description: "Book tickets to West End Shows, Concerts and more",
  logo: "/assets/images/logo.png",
  favicons: ["favicon.png", "apple-touch-icon.png"],
  detectLocale: true,
  detectLanguage: false,
};
